export default function getCroppedImg(imageSrc, croppedAreaPixels,originalFileName) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.crossOrigin = "anonymous"; // to avoid CORS issues if needed

    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );

      canvas.toBlob((blob) => {
        if (blob) {
          // ✅ Use original file name
          const file = new File([blob], originalFileName, { type: blob.type });
         resolve({ blob, file });;
        } else {
          reject(new Error("Canvas is empty"));
        }
      }, "image/jpeg")
    };

    image.onerror = reject;
  });
}
